import WIDGETS from './widgets';

export default {
	name: 'form_invite',
	spacing: 2,
	widgets: [{ content: WIDGETS.FORM_INVITE, breakpoints: { xs: 12 } }],
};